import { ToolBase, ToolDescription } from "../../../agents/base";
import { createTelemetry, isDetailedReadMode, normalizeReadRequest, resolveSessionId, unwrapRequest, } from "../readHelpers";
import { ReadContentParamsSchema } from "./readContent.schema";
const SYSTEM_PROMPT_DESCRIPTION = `### readContent
Read worksheet values/formulas by range and mode.

For detailed modes, always provide an explicit targetRange.`;
export function createReadContentTool(runner, fallbackSessionId) {
    return new ReadContentTool(runner, fallbackSessionId).toRuntimeToolDefinition();
}
export class ReadContentTool extends ToolBase {
    constructor(runner, fallbackSessionId) {
        super();
        this.runner = runner;
        this.fallbackSessionId = fallbackSessionId;
        this.name = "readContent";
        this.description = new ToolDescription("readContent", "Read worksheet values/formulas by range and mode.", ReadContentParamsSchema);
        this.paramsSchema = ReadContentParamsSchema;
        this.systemPromptDescription = SYSTEM_PROMPT_DESCRIPTION;
        this.fieldsToCheck = [
            { name: "uiDescription", type: "string", list_status: false, order: 0 },
        ];
        this.listsToCheck = [
            {
                name: "readContent",
                type: "array",
                item_type: "object",
                list_status: true,
                order: 1,
                check_sub_field: "sheetName",
            },
        ];
    }
    setSessionId(sessionId) {
        this.fallbackSessionId = sessionId;
    }
    async execute(args) {
        const startedAt = Date.now();
        const sessionId = resolveSessionId(args, this.fallbackSessionId);
        const raw = unwrapRequest(args);
        const request = normalizeReadRequest({
            readContent: raw.readContent,
        });
        const readContent = request.readContent || [];
        const invalidItems = readContent.filter((item) => isDetailedReadMode(item.mode) && !item.targetRange);
        if (invalidItems.length > 0) {
            const telemetry = createTelemetry(readContent.length, startedAt);
            return {
                success: false,
                data: { readContent: [] },
                results: { readContent: [] },
                errors: ["detailedValues/detailedValuesAndFormulas require targetRange."],
                telemetry,
            };
        }
        const result = await this.runner.read({ readContent }, { sessionId });
        const payload = (result.data || {});
        const readContentResult = payload.readContent || [];
        return {
            ...result,
            data: { readContent: readContentResult },
            results: { readContent: readContentResult },
            telemetry: result.telemetry || createTelemetry(readContent.length, startedAt),
        };
    }
}
